import React, { useState } from 'react';
import './ProductResources.css';

const productResources = [
  {
    product: 'aivionGrade',
    description: 'See how responsible AI can transform assessment.',
    resources: [
      {
        label: 'Watch the aivionGrade film',
        type: 'Video',
        url: 'https://aivionlimited.sharepoint.com/sites/IntelliGrade/_layouts/15/stream.aspx?id=%2Fsites%2FIntelliGrade%2FShared%20Documents%2FAIVION%20GRADE%20%E2%80%94%20Transforming%20Assessment%20with%20Responsible%20AI%5FFilm%2Emp4&referrer=StreamWebApp%2EWeb&referrerScenario=AddressBarCopied%2Eview%2E2063dc2c%2D2056%2D435c%2Dbe7a%2D3852a1b61ab7',
        embedUrl: 'https://aivionlimited-my.sharepoint.com/personal/munish_dhall_aivion_ai/_layouts/15/embed.aspx?UniqueId=4ddbdf31-cb88-4212-99f6-fc424f7a50a7&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create'
      },
      {
        label: 'View the aivionGrade presentation',
        type: 'Presentation',
        url: 'https://aivionlimited-my.sharepoint.com/:b:/g/personal/munish_dhall_aivion_ai/IQAI5YhY4ITlSYycyIgKAjXMAQcR6y-GQYwkuR---V-sBps',
        embedUrl: 'https://aivionlimited-my.sharepoint.com/personal/munish_dhall_aivion_ai/_layouts/15/embed.aspx?UniqueId=5888e508-84e0-49e5-8c9c-c8880a0235cc'
      }
    ]
  },
  {
    product: 'aivionReach',
    description: 'Explore the employment platform through its video and presentation.',
    resources: [
      {
        label: 'Watch the aivionReach video',
        type: 'Video',
        url: 'https://aivionlimited-my.sharepoint.com/personal/munish_dhall_aivion_ai/_layouts/15/stream.aspx?id=%2Fpersonal%2Fmunish_dhall_aivion_ai%2FDocuments%2FaivionReach_Presentation_External%2FaivionReach.mp4&nav=eyJyZWZlcnJhbEluZm8iOnsicmVmZXJyYWxBcHAiOiJPbmVEcml2ZUZvckJ1c2luZXNzIiwicmVmZXJyYWxBcHBQbGF0Zm9ybSI6IldlYiIsInJlZmVycmFsTW9kZSI6InZpZXciLCJyZWZlcnJhbFZpZXciOiJNeUZpbGVzTGlua0NvcHkifX0&ct=1791640815302&or=OWA-NT-Mail&cid=1518b8fc-cb30-da58-3ba9-5ecb4bfd512d&ga=1&referrer=StreamWebApp.Web&referrerScenario=AddressBarCopied.view.782fd1d9-5354-4e0f-82e1-919116e88677',
        embedUrl: 'https://aivionlimited-my.sharepoint.com/personal/munish_dhall_aivion_ai/_layouts/15/embed.aspx?UniqueId=7220bae0-152f-4849-88cb-bf15ef03f939&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create'
      },
      {
        label: 'View the aivionReach presentation',
        type: 'Presentation',
        url: 'https://aivionlimited-my.sharepoint.com/personal/munish_dhall_aivion_ai/_layouts/15/onedrive.aspx?id=%2Fpersonal%2Fmunish%5Fdhall%5Faivion%5Fai%2FDocuments%2FaivionReach%5FPresentation%5FExternal%2FaivionReach%2Epdf&parent=%2Fpersonal%2Fmunish%5Fdhall%5Faivion%5Fai%2FDocuments%2FaivionReach%5FPresentation%5FExternal&ct=1791640539479&or=OWA%2DNT%2DMail&cid=0ca188e9%2D621d%2D2bbe%2Dece0%2D158d4cb92e9e&ga=1',
        embedUrl: 'https://aivionlimited-my.sharepoint.com/personal/munish_dhall_aivion_ai/_layouts/15/embed.aspx?UniqueId=fefb7c82-e9a6-4f9f-aace-1d15d238cf8c'
      }
    ]
  }
];

// Local-only preview switch: lets the developer inspect the embeds without
// submitting the lead form. Production deployments keep the form gate enabled.
const isLocalPreview = process.env.NODE_ENV === 'development';
const RESOURCE_SESSION_KEY = 'aivion-product-resource-access';

const ProductResources = () => {
  const [form, setForm] = useState({ name: '', email: '', company: '' });
  const [isSending, setIsSending] = useState(false);
  const [hasSessionAccess, setHasSessionAccess] = useState(() => (
    typeof window !== 'undefined' && window.sessionStorage.getItem(RESOURCE_SESSION_KEY) === 'granted'
  ));
  const [selectedResource, setSelectedResource] = useState(null);
  const [activeResource, setActiveResource] = useState(null);
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const handleChange = (event) => {
    setForm((current) => ({ ...current, [event.target.name]: event.target.value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSending(true);
    setMessage('');
    setIsError(false);

    try {
      const response = await fetch('/api/sendEmail', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ type: 'productResourceAccess', ...form })
      });
      const contentType = response.headers.get('content-type') || '';
      if (!contentType.toLowerCase().includes('json')) {
        const isLocal = ['localhost', '127.0.0.1'].includes(window.location.hostname);
        throw new Error(isLocal
          ? 'The local email API is not running. Start Azure Functions with “npm run start:api”, then try again.'
          : 'The resource email service is unavailable right now. Please try again later.');
      }

      const result = await response.json();
      if (!response.ok) throw new Error(result.message || 'We could not send the resource links. Please try again.');

      window.sessionStorage.setItem(RESOURCE_SESSION_KEY, 'granted');
      setHasSessionAccess(true);
      setMessage(`Thanks, ${form.name}. Your selected resource is opening now. You can view the other resources without submitting the form again during this session.`);
      window.open(selectedResource.url, '_blank', 'noopener,noreferrer');
      setSelectedResource(null);
    } catch (error) {
      setIsError(true);
      setMessage(error.message || 'Unable to send the resource links. Please try again later.');
    } finally {
      setIsSending(false);
    }
  };

  const handleResourceClick = (resource) => {
    if (isLocalPreview || hasSessionAccess) {
      window.open(resource.url, '_blank', 'noopener,noreferrer');
      return;
    }
    setSelectedResource(resource);
    setMessage('');
    setIsError(false);
  };

  const previewResources = activeResource ? [activeResource] : [];

  return (
    <section className="product-resources" aria-labelledby="product-resources-title">
      <div className="product-resources__inner">
        <header className="product-resources__heading">
          <p className="product-resources__eyebrow">SEE OUR PRODUCTS IN ACTION</p>
          <h2 id="product-resources-title">Videos &amp; product presentation</h2>
          <p>Explore our product videos and presentation. Submit your details to view a resource here or open it in a new tab.</p>
        </header>

        <div className="product-resources__grid">
          {productResources.map((product) => (
            <article className="product-resources__card" key={product.product}>
              <p className="product-resources__card-label">PRODUCT RESOURCES</p>
              <h3>{product.product}</h3>
              <p>{product.description}</p>
              <div className="product-resources__links">
                {product.resources.map((resource) => (
                  <button
                    className="product-resources__resource-button"
                    type="button"
                    key={resource.type}
                    onClick={() => handleResourceClick(resource)}
                  >
                    <span>{resource.label}</span><small>{resource.type} ↗</small>
                  </button>
                ))}
              </div>
            </article>
          ))}
        </div>

        {isLocalPreview && <p className="product-resources__status" role="status">Local preview mode: resources open in a new tab without submitting the request form.</p>}
        {!isLocalPreview && message && <p className={`product-resources__status${isError ? ' is-error' : ''}`} role="status">{message}</p>}

        {previewResources.map((resource) => (
          <section className="product-resources__preview" key={resource.type + resource.label} aria-label={`${resource.label} preview`}>
            <div className="product-resources__preview-heading">
              <h3>{resource.label}</h3>
              {!isLocalPreview && <button type="button" onClick={() => setActiveResource(null)}>Close preview</button>}
            </div>
            {resource.embedUrl ? (
              <iframe
                src={resource.embedUrl}
                title={resource.label}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            ) : null}
            <a className="product-resources__open-link" href={resource.url} target="_blank" rel="noreferrer">
              Open this resource in a new tab
            </a>
          </section>
        ))}

        {selectedResource && (
          <div className="product-resources__dialog-backdrop" onMouseDown={(event) => {
            if (event.target === event.currentTarget) setSelectedResource(null);
          }}>
            <section className="product-resources__dialog" role="dialog" aria-modal="true" aria-labelledby="resource-form-title">
              <button className="product-resources__close" type="button" onClick={() => setSelectedResource(null)} aria-label="Close form">×</button>
              <p className="product-resources__eyebrow">BEFORE YOU CONTINUE</p>
              <h3 id="resource-form-title">Open {selectedResource.label.replace(/^(Watch|View) the /, '')}</h3>
              <p className="product-resources__dialog-copy">Enter your details once to continue. We’ll send a brief confirmation email, and you can view the selected resource here. SharePoint may ask you to sign in if it isn’t shared publicly.</p>
              <form className="product-resources__form" onSubmit={handleSubmit}>
                <label>Name<input name="name" value={form.name} onChange={handleChange} autoComplete="name" required maxLength={120} /></label>
                <label>Email address<input type="email" name="email" value={form.email} onChange={handleChange} autoComplete="email" required maxLength={254} /></label>
                <label>Company name<input name="company" value={form.company} onChange={handleChange} autoComplete="organization" required maxLength={160} /></label>
                <p className="product-resources__privacy">We’ll use these details to record your request and send a confirmation. You won’t need to submit them again during this browser session.</p>
                {message && <p className={`product-resources__status${isError ? ' is-error' : ''}`} role="status">{message}</p>}
                <button type="submit" disabled={isSending}>{isSending ? 'Sending…' : 'Continue to resource'}</button>
              </form>
            </section>
          </div>
        )}
      </div>
    </section>
  );
};

export default ProductResources;
